import { Component, OnInit, NgZone, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '../../../_services/translate.service';
import { ApiService } from '../../../_services/api.service';
import { AuthenticationService } from '../../../_services/authentication.service';
import { first } from 'rxjs/operators';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmPasswordValidator } from '../../../_validators/confirm-password.validator';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
declare var $: any;
import { AnpiService } from '../../../_services/anpi-code.service';
import { timer } from 'rxjs';
import { Subscription } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { Location } from '@angular/common';
import Swiper, { Autoplay, EffectFade } from 'swiper';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit, AfterViewInit {

  currentLang: any;
  isSubmitted = false;
  public languageForm: FormGroup;
  public signUpForm: FormGroup;
  public signInForm: FormGroup;
  public otpForm: FormGroup;
  public otpFormSignIn: FormGroup;
  public forgotPasswordForm: FormGroup;
  public otpFormForgotPassword: FormGroup;
  public resetPasswordForm: FormGroup;
  public EmployeeChangePasswordForm: FormGroup;
  secondsLeft: any;
  currentUser: any;
  employeeSignin: any;
  login: any;
  url: any;
  employee = false;
  accountDetails: any;
  isBusiness = false;
  response: any;
  forgotPassword = false;
  currentValue: any;
  phoneNumber: any;
  isCountDown: boolean = true;
  loginStatus: any;
  block_message: any;
  copied: boolean = false;
  countdownSubscription: Subscription;
  uuid: string;
  deviceToken: string;
  deviceDetails: any;
  messageTitle: string;
  messageDescription: string;
  is_cnamgsPdf: boolean;
  is_cnssPdf: boolean;
  faqAllList: any;
  faqDetails: any;
  openFaqIndices: Set<number> = new Set();
  constructor(private router: Router,
    private ngZone: NgZone,
    private api: ApiService,
    private translate: TranslateService,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private ngxUiLoaderService: NgxUiLoaderService,
    private snackBar: MatSnackBar,
    private location: Location,
    private anpiService: AnpiService) {
    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
      if (this.accountDetails && this.accountDetails.current_user == 1) {
        this.login = this.accountDetails.current_user;
      } else if (this.accountDetails && this.accountDetails.current_user == 2) {
        this.loginStatus = this.accountDetails.login_status;
        if (this.loginStatus == 1) {
          this.login = this.accountDetails.current_user;
        } else {
          console.log("new employeeeeeeeeee");
        }
      }
      console.log("36 login value:", this.login)
      console.log("36 login Status :", this.loginStatus)
      if (this.login == "1") {
        this.employee = false;
      } else {
        this.employee = true;
      }
      if (this.accountDetails.GNI == "1") {
        this.isBusiness = true;
      }
    }
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(['/']);
    }
    this.getDeviceDetails();
  }

  ngOnInit() {
    const inputs = document.querySelectorAll(".signInOtp input");
    const otpInputs = document.querySelectorAll("#otp input");
    const allInputs = Array.from(inputs).concat(Array.from(otpInputs));

    allInputs.forEach((input, index) => {
      const inputElement = input as HTMLElement;
      inputElement.dataset.index = index.toString();

      inputElement.addEventListener("keyup", handleOtp);
      inputElement.addEventListener("paste", handleOnPasteOtp);
    });

    function handleOtp(e) {
      const input = e.target;
      let value = input.value;
      let isValidInput = value.match(/[0-9a-z]/gi);
      input.value = "";
      input.value = isValidInput ? value[0] : "";

      let fieldIndex = input.dataset.index;
      let nextElement = input.nextElementSibling;
      let prevElement = input.previousElementSibling;

      if (nextElement && fieldIndex < allInputs.length - 1 && isValidInput) {
        nextElement.focus();
      }

      if (e.key === "Backspace" && prevElement && fieldIndex > 0) {
        prevElement.focus();
      }
    }

    function handleOnPasteOtp(e) {
      const data = e.clipboardData.getData("text");
      const value = data.split("");

      // Use allInputs.length to check the length
      if (value.length === allInputs.length) {
        allInputs.forEach((input, index) => {
          const inputElement = input as HTMLInputElement;
          inputElement.value = value[index];
        });
      }
    }
    this.ngZone.run(() => {
      this.url = window.location.pathname.split('/')[1];

    });
    this.signInForm = this.formBuilder.group({
      ccps_id: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]],
      phone: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]],
      password: ['', [Validators.required]],
    });

    this.signUpForm = this.formBuilder.group({
      first_name: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ, -]+$")]],
      last_name: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ, -]+$")]],
      email: ['', [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$")]],
      mobile: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(8), Validators.maxLength(8)]],
      password: ['', [Validators.required, Validators.minLength(8), Validators.pattern("^(?!.*\\s)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*#?&]).{7,}$")]],
      confirmPassword: ['', [Validators.required]],
    }, { validator: ConfirmPasswordValidator.MatchPassword });

    this.otpForm = this.formBuilder.group({
      otp1: ['', [Validators.required]],
      otp2: ['', [Validators.required]],
      otp3: ['', [Validators.required]],
      otp4: ['', [Validators.required]],
    })

    this.otpFormSignIn = this.formBuilder.group({
      otp1: ['', [Validators.required]],
      otp2: ['', [Validators.required]],
      otp3: ['', [Validators.required]],
      otp4: ['', [Validators.required]],
    })
    this.forgotPasswordForm = this.formBuilder.group({
      phone_no: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]],
    })
    this.otpFormForgotPassword = this.formBuilder.group({
      otp1: ['', [Validators.required]],
      otp2: ['', [Validators.required]],
      otp3: ['', [Validators.required]],
      otp4: ['', [Validators.required]],
    })
    this.resetPasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(8), Validators.pattern("^(?!.*\\s)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*#?&]).{7,}$")]],
      confirmPassword: ['', [Validators.required]],
    }, { validator: ConfirmPasswordValidator.MatchPassword })

    this.EmployeeChangePasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(8), Validators.pattern("^(?!.*\\s)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*#?&]).{7,}$")]],
      confirmPassword: ['', [Validators.required]],
    }, { validator: ConfirmPasswordValidator.MatchPassword });

    if (!this.api.getValidationStatus()) {
      this.api.getFormValidation(this.otpForm);
      this.api.getFormValidation(this.signUpForm);
      this.api.getFormValidation(this.signInForm);
      this.api.getFormValidation(this.otpFormSignIn);
    }

    this.languageForm = this.formBuilder.group({
      lang: ['', []],
    });
    this.currentValue = this.authenticationService.currentUserValue;
    $('#service_slider').owlCarousel({
      // animateOut: 'slideOutUp',
      // animateIn: 'pulse',
      loop: true,
      margin: 0,
      stagePadding: 0,
      nav: false,
      dots: false,
      touchDrag: false,
      mouseDrag: false,
      // autoPlay:true,
      items: 1,
      //navText : ['<img src="assets/images/arrow-left.svg">','<img src="assets/images/arrow-right.svg">'],
      autoplay: false
    });

    var owl = $('#service_slider');
    owl.owlCarousel();

    $('.next-review-btn').click(function () {
      // slider animation
      owl.trigger('next.owl.carousel');
    });

    $('.prev-review-btn').click(function () {
      // slider animation
      owl.trigger('prev.owl.carousel');
    });
    // Splitting();
    // ScrollOut({
    //  threshold: .2,
    // });
    AOS.init({
      disable: function () {
        var maxWidth = 600;
        return window.innerWidth < maxWidth;
      }
    });

    this.currentLang = localStorage.getItem('language') || "fr";
    this.languageForm.get('lang').setValue(this.currentLang);
    if (this.currentLang == 'fr') {
      $('.checkbox').prop('checked', false);
    } else {
      $('.checkbox').prop('checked', true);
    }
    if (this.currentLang == 'fr') {
      $('.myCheckbox').prop('checked', true);
      $("#lang").text("FR");
    } else {
      $('.myCheckbox').prop('checked', false);
      $("#lang").text("EN");
    }
    console.log(this.languageForm.get('lang').value);
    // Get all select elements
    // const selectElements = document.querySelectorAll("select");

    // // Iterate over each select element
    // selectElements.forEach((selectElement) => {
    //   // Create a new custom select container
    //   const selectContainer = document.createElement("div");
    //   selectContainer.classList.add("select");

    //   // Create the custom select display element
    //   const selectStyled = document.createElement("div");
    //   selectStyled.classList.add("select-styled");
    //   selectStyled.textContent = selectElement.options[0].textContent;

    //   // Create the options list
    //   const selectOptions = document.createElement("ul");
    //   selectOptions.classList.add("select-options");

    //   // Populate the options list
    //   for (let i = 0; i < selectElement.options.length; i++) {
    //     const option = document.createElement("li");
    //     option.textContent = selectElement.options[i].textContent;
    //     option.setAttribute("rel", selectElement.options[i].value);

    //     if (selectElement.options[i].selected) {
    //       option.classList.add("is-selected");
    //     }

    //     // Handle option click event
    //     option.addEventListener("click", (e) => {
    //    console.log(e)
    //       e.stopPropagation();
    //       selectStyled.textContent = option.textContent;
    //       selectElement.value = option.getAttribute("rel");

    //       // Remove 'is-selected' class from all options and add it to the clicked option
    //       selectOptions.querySelectorAll("li.is-selected").forEach((li) => {
    //         li.classList.remove("is-selected");
    //       });
    //       option.classList.add("is-selected");

    //       selectOptions.style.display = "none";
    //       selectStyled.classList.remove("active");
    //     });

    //     selectOptions.appendChild(option);
    //   }

    //   // Handle custom select click event
    //   selectStyled.addEventListener("click", (e) => {
    //     e.stopPropagation();
    //     // Close other open custom selects
    //     document.querySelectorAll(".select-styled.active").forEach((styledSelect) => {
    //       if (styledSelect !== selectStyled) {
    //         styledSelect.classList.remove("active");
    //         (selectStyled.nextElementSibling as HTMLElement).style.display = "none";
    //       }
    //     });

    //     selectStyled.classList.toggle("active");
    //     selectOptions.style.display = selectStyled.classList.contains("active") ? "block" : "none";
    //   });

    //   // Handle document click event to close the custom select
    //   document.addEventListener("click", () => {
    //     selectStyled.classList.remove("active");
    //     selectOptions.style.display = "none";
    //   });

    //   // Hide the original select element and append the custom elements
    //   selectElement.classList.add("select-hidden");
    //   selectElement.parentNode.insertBefore(selectContainer, selectElement);
    //   selectContainer.appendChild(selectStyled);
    //   selectContainer.appendChild(selectOptions);
    // });


    if (localStorage.getItem('currentUser')) {
      this.getFaqList();
      this.anpiService.faqEvent.subscribe(() => {
        console.log("35", this.faqDetails)
        this.getFaqList();
      });
    }
  }

  //   var signin = document.getElementById("signin");
  //  var signup = document.getElementById("signup");
  //  var signin_choice = document.getElementById("signin_as");
  //  var otp = document.getElementById("otp");

  // showSignin(){
  //     document.getElementById("signup").style.display = "none";
  //      document.getElementById("signin").style.display = "grid";
  // };

  ngAfterViewInit() {
    console.log("asdsadsadsad")
    this.currentValue = this.authenticationService.currentUserValue;
    if (this.loginStatus == 0) {
      console.log("348")
      this.openChangePassword()
    }

    // Register Swiper modules
    Swiper.use([Autoplay, EffectFade]);

    new Swiper('.home-banner-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      // autoplay: {
      //   delay: 3000,
      //   disableOnInteraction: false,
      // },
    });
  }

  showSignup() {
    this.signInForm.reset();
    document.getElementById("signin_as").style.display = "block";
    document.getElementById("signin").style.display = "none";
    document.getElementById("otpSignIn").style.display = "none";
    this.isSubmitted = false;
    $('#signinModal').modal('hide');
    console.log('498')
    setTimeout(function () {
      $('#signupModal').modal('show');

    }, 500);

  }
  onSubmitSignUp() {
    this.isSubmitted = true;
    console.log("submitted!!")
    if (this.signUpForm.invalid) {
      console.log("196", this.signUpForm)
      return;
    }
    var data = this.signUpForm.value;
    const push_token = localStorage.getItem('pushtoken');
    if (push_token) {
      data['fcfm_token'] = push_token;
    }

    this.phoneNumber = this.f.mobile.value;
    console.log("194", data)
    this.ngxUiLoaderService.start();
    this.api.signUp(data).pipe(first())
      .subscribe(res => {
        console.log("233333333333")
        this.isSubmitted = false;
        this.ngxUiLoaderService.stop();
        if (res.status == 200) {
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
          this.currentUser = 1;
          document.getElementById("signup").style.display = "none";
          document.getElementById("otp").style.display = "block";
          console.log("234", this.isSubmitted)
          this.countDown();
        } else {
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
        });

  }
  showSignin() {
    $('#signupModal').modal('hide');
    console.log('498')
    setTimeout(function () {
      $('#signinModal').modal('show');
    }, 500);
    document.getElementById("signup").style.display = "grid";
    document.getElementById("otp").style.display = "none";

  }
  showSignInForm(val) {
    this.currentUser = val;
    if (val == 1) {
      this.g['phone'].setValidators([Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]);
      this.g['phone'].updateValueAndValidity();
      this.employeeSignin = false;
      this.g['ccps_id'].clearValidators();
      this.g['ccps_id'].updateValueAndValidity();
    } else {
      this.g['ccps_id'].setValidators([Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]);
      this.g['ccps_id'].updateValueAndValidity();
      this.employeeSignin = true;
      this.g['phone'].clearValidators();
      this.g['phone'].updateValueAndValidity();
    }
    console.log(this.currentUser)
    document.getElementById("signin_as").style.display = "none";
    document.getElementById("signin").style.display = "block";
  }

  onSubmitOtp() {

    this.isSubmitted = true;
    if (this.otpForm.invalid) {
      console.log("254", this.otpForm)
      return;
    }
    var data = {
      mobile: this.f.mobile.value,
      otp: this.h.otp1.value + this.h.otp2.value + this.h.otp3.value + this.h.otp4.value
    };
    console.log("260", data);
    this.ngxUiLoaderService.start();
    this.authenticationService.signupOtp(data).pipe(first())
      .subscribe(res => {
        this.ngxUiLoaderService.stop();
        if (res.status == 200) {
          this.getAccountData();
          this.isSubmitted = false;
          this.signUpForm.reset();
          this.otpForm.reset();
          $('#signupModal').modal('hide');
          document.getElementById("signup").style.display = "grid";
          document.getElementById("otp").style.display = "none";
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
          // localStorage.setItem('login', "employer");
          // this.router.navigate(['/get-started']);
          console.log("275");
        } else {
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }

      },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }
  onSubmitSignInOtp() {

    this.isSubmitted = true;
    if (this.otpFormSignIn.invalid) {
      console.log("254", this.otpForm)
      return;
    }
    var data = {
      username: this.currentUser == 2 ? this.g.ccps_id.value : this.g.phone.value,
      otp: this.i.otp1.value + this.i.otp2.value + this.i.otp3.value + this.i.otp4.value,
      entity_type: this.currentUser,
      device_token: this.deviceToken
    };
    console.log("260", data);
    this.ngxUiLoaderService.start();
    this.authenticationService.loginOtp(data).pipe(first())
      .subscribe(res => {
        if (res.status == 200) {
          this.isSubmitted = false;
          this.getAccountData();

          // $('#signinModal').modal('hide');
          this.otpFormSignIn.reset();
          // document.getElementById("signInOtp").style.display = "none";
          // document.getElementById("signin_as").style.display = "block";
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        } else {
          this.ngxUiLoaderService.stop();
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }

      },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  getAccountData() {
    console.log("442 get account details")
    this.api.getAccountDetails().pipe(first())
      .subscribe(res => {
        this.ngxUiLoaderService.stop();
        console.log("44333333333333333", res)
        this.response = res.results;
        if (res.status == 200) {
          console.log("123456789")
          this.accountDetails = this.response;
          if (this.response.current_user) {
            this.currentUser = this.response.current_user;
          } else if (this.response.employee.current_user) {
            this.currentUser = this.response.employee.current_user;
          }

          if (this.login == "1") {
            this.employee = false;
            this.login = this.currentUser;
          } else {
            this.employee = true;
          }
          if (this.accountDetails.GNI == "1") {
            this.isBusiness = true;
          }
          if (this.currentUser == 1) {
            this.loginStatus = this.accountDetails.login_status
            if (this.loginStatus == 0) {
              document.getElementById("signin").style.display = "none";
              document.getElementById("otpSignIn").style.display = "none";
              document.getElementById("ChangePasswordEmployee").style.display = "block";


            } else {
              $('#signinModal').modal('hide');
              const data = JSON.stringify(this.accountDetails);
              localStorage.setItem('currentUserDetails', data);
              console.log("468", data)
              console.log("employer logged in")
              console.log("410 account details.gni", this.accountDetails.GNI)
              if (this.accountDetails && this.accountDetails.GNI == 1) {
                console.log("GNI show dashboard")
                this.router.navigate(['/dashboard']);
              } else {
                console.log("no GNI show getstarted")
                this.router.navigate(['/get-started']);
              }
            }

          } else if (this.currentUser == 2) {
            this.loginStatus = this.accountDetails.employee.login_status
            const data = JSON.stringify(this.accountDetails.employee);
            localStorage.setItem('currentUserDetails', data);
            if (this.loginStatus == 1) {
              $('#signinModal').modal('hide');
              this.login = this.currentUser;
              console.log("481", 531)
              this.router.navigate(['/dashboard']);
            } else {
              this.currentValue = this.authenticationService.currentUserValue;
              document.getElementById("signin").style.display = "none";
              document.getElementById("otpSignIn").style.display = "none";
              document.getElementById("ChangePasswordEmployee").style.display = "block";
              console.log("533")
            }
          }

        } else {
          console.log("no result")
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {
          console.log("errorrrrrrrrr")
          this.ngxUiLoaderService.stop();
        });
    console.log("no result")
  }
  closeSignUpModal() {
    this.signUpForm.reset();
    this.otpForm.reset();
    this.isSubmitted = false;
    $('#signupModal').modal('hide');
    document.getElementById("signup").style.display = "grid";
    document.getElementById("otp").style.display = "none";
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }
  closeSignInModal() {
    this.signInForm.reset();
    this.otpFormSignIn.reset();
    this.forgotPasswordForm.reset();
    this.otpFormForgotPassword.reset();
    this.resetPasswordForm.reset();
    this.EmployeeChangePasswordForm.reset();
    this.isSubmitted = false;
    $('#signinModal').modal('hide');
    document.getElementById("signin_as").style.display = "block";
    document.getElementById("signin").style.display = "none";
    document.getElementById("otp").style.display = "none";
    document.getElementById("otpSignIn").style.display = "none";
    document.getElementById("forgotPassword").style.display = "none";
    document.getElementById("forgotPasswordOtp").style.display = "none";
    document.getElementById("resetPassword").style.display = "none";
    document.getElementById("ChangePasswordEmployee").style.display = "none";
    this.forgotPassword = false;
    this.g['phone'].clearValidators();
    this.g['phone'].updateValueAndValidity();
    this.g['ccps_id'].clearValidators();
    this.g['ccps_id'].updateValueAndValidity();
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }
  onSubmitSignIn() {
    this.isSubmitted = true;
    console.log("32sadadadadadadddadadadadadadwecwd6", this.signInForm)
    console.log("306");
    if (this.signInForm.invalid) {
      return;
    }
    if (this.currentUser == 2) {
      var data = {
        username: this.g.ccps_id.value,
        password: this.g.password.value,
        entity_type: this.currentUser,
        device_token: this.deviceToken
      }
    } else {
      var data = {
        username: this.g.phone.value,
        password: this.g.password.value,
        entity_type: this.currentUser,
        device_token: this.deviceToken
      }
      this.phoneNumber = this.g.phone.value;
      const push_token = localStorage.getItem('pushtoken');
      if (push_token) {
        data['fcfm_token'] = push_token;
      }

    }
    console.log("331", data)
    this.ngxUiLoaderService.start();
    this.authenticationService.login(data).pipe(first())
      .subscribe(res => {
        this.ngxUiLoaderService.stop();
        console.log(res, "res");
        this.block_message = res;
        if (res.status == 200) {
          this.isSubmitted = false;
          if (res.message) {
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }
          console.log("368", res)
          if (this.currentUser == 1) {
            document.getElementById("signin").style.display = "none";
            document.getElementById("otpSignIn").style.display = "block";
            this.countDown();
          }
          if (this.currentUser == 2) {
            // this.getAccountData();

            document.getElementById("signin").style.display = "none";
            document.getElementById("otpSignIn").style.display = "block";
            this.countDown();

          }

        } else {
          console.log("557")
          if (this.block_message.block == 1) {
            $('#myModal').modal('show');
          }
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
          console.log("397 status not 200")
          this.signInForm.get('password').setValue("");
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
        });
    this.isSubmitted = false;

  }

  copyCodeToClipboard(): void {
    if (this.block_message && this.block_message.code) {
      const textarea = document.createElement('textarea');
      textarea.value = this.block_message.code;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      console.log('Code copied to clipboard:', this.block_message.code);
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    } else {
      console.error('No code to copy');
    }
  }

  showLogin() {
    console.log("589")

    document.getElementById("signin_as").style.display = "block";
      document.getElementById("signin").style.display = "none";
      document.getElementById("forgotPassword").style.display = "none";
      document.getElementById("forgotPasswordOtp").style.display = "none";
      document.getElementById("otpSignIn").style.display = "none";
      document.getElementById("ChangePasswordEmployee").style.display = "none";
    if ($('#signinModal').modal('show')) {
      this.signInForm.reset()
      this.isSubmitted = false;
      $('#signinModal').modal('hide');
      document.getElementById("signin_as").style.display = "block";
     

    }
    $('#signinModal').modal('show');
  }

  handleArrowClick() {
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(['/dashboard']);
    } else {
      this.showLogin();
    }
  }
  showSignUp() {
    console.log("598")
    if ($('#signupModal').modal('show')) {
      this.signUpForm.reset()
      this.isSubmitted = false;
      $('#signupModal').modal('hide');
    }
    $('#signupModal').modal('show');
  }
  openNav() {
    document.getElementById("mySidenav").style.width = "305px";
    document.getElementById("main").style.marginRight = "0px";
    document.getElementById("menuOverlay").style.display = "block";

  }

  closeNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("main").style.marginRight = "0";
    document.getElementById("menuOverlay").style.display = "none";
  }


  setLang(lang) {
    console.log('aaa')
    // console.log(lang.target.value)
    // console.log(lang.detail.value)
    // console.log(lang)
    this.currentLang = lang;
    var useLang = { language: this.currentLang };
    this.translate.setCurrentLangage(useLang);
    localStorage.setItem('language', lang);

    this.changeLang();
  }

  changeLang() {
    this.translate.use(this.currentLang);
  }

  checkValue(e) {
    console.log(e)
    if (e == true) {
      this.setLang('fr');
      $("#lang").text("FR");
    } else {
      this.setLang('en');
      $("#lang").text("EN");
    }
  }

  eyeclose(val) {
    if (val == 1) {
      console.log("ASDsadsad")
      $('#eye').toggleClass('fa-eye fa-eye-slash');
      var passwordField = $('#password');
      var currentType = passwordField.attr('type');

      if (currentType === 'password') {
        passwordField.attr('type', 'text');
      } else {
        passwordField.attr('type', 'password');
      }
    } else if (val == 2) {
      console.log("ASDsadsad")
      $('#eye1').toggleClass('fa-eye fa-eye-slash');
      var passwordField = $('#password1');
      var currentType = passwordField.attr('type');

      if (currentType === 'password') {
        passwordField.attr('type', 'text');
      } else {
        passwordField.attr('type', 'password');
      }
    } else if (val == 3) {
      console.log("aa3")
      $('#eye3').toggleClass('fa-eye fa-eye-slash');
      var passwordField = $('#password3');
      var currentType = passwordField.attr('type');

      if (currentType === 'password') {
        passwordField.attr('type', 'text');
      } else {
        passwordField.attr('type', 'password');
      }
    } else if (val == 4) {
      console.log("aaa4")
      $('#eye4').toggleClass('fa-eye fa-eye-slash');
      var passwordField = $('#password4');
      var currentType = passwordField.attr('type');

      if (currentType === 'password') {
        passwordField.attr('type', 'text');
      } else {
        passwordField.attr('type', 'password');
      }
    } else if (val == 6) {
      console.log("aaa4")
      $('#eye6').toggleClass('fa-eye fa-eye-slash');
      var passwordField = $('#password6');
      var currentType = passwordField.attr('type');

      if (currentType === 'password') {
        passwordField.attr('type', 'text');
      } else {
        passwordField.attr('type', 'password');
      }
    } else if (val == 7) {
      console.log("aaa4")
      $('#eye7').toggleClass('fa-eye fa-eye-slash');
      var passwordField = $('#password7');
      var currentType = passwordField.attr('type');

      if (currentType === 'password') {
        passwordField.attr('type', 'text');
      } else {
        passwordField.attr('type', 'password');
      }
    } else {
      console.log("ASDsadsaasd11111111")
      $('#eye2').toggleClass('fa-eye fa-eye-slash');
      var passwordField = $('#password2');
      var currentType = passwordField.attr('type');

      if (currentType === 'password') {
        passwordField.attr('type', 'text');
      } else {
        passwordField.attr('type', 'password');
      }
    }
  }
  get f() { return this.signUpForm.controls; };
  get g() { return this.signInForm.controls; };
  get h() { return this.otpForm.controls; }
  get i() { return this.otpFormSignIn.controls; }
  get j() { return this.forgotPasswordForm.controls; }
  get k() { return this.otpFormForgotPassword.controls; }
  get l() { return this.resetPasswordForm.controls; }
  get m() { return this.EmployeeChangePasswordForm.controls; }

  getChangelang(e) {
    if (e.target.checked == true) {
      var lang = 'en';
    } else {
      lang = 'fr';
    }
    this.setLang(lang)
  }
  getBusiness() {
    return localStorage.getItem('business');
  }
  getCnamgs() {
    this.router.navigate(['/cnss-reports/cnamgs'], { state: { data: 'cnamgs' } });
  }
  getCnamgsemployee() {
    this.router.navigate(['/cnss/cnamgs'], { state: { data: 'cnamgs' } });
  }

  clearLocalStorage() {
    localStorage.removeItem('business');
    localStorage.removeItem('bank');
    localStorage.removeItem('employees');
    localStorage.removeItem('cnssForm');
    localStorage.removeItem('cnamgsForm');
    localStorage.removeItem('account_status');
  }
  showForgotPassword() {
    this.forgotPassword = true
    this.isSubmitted = false;
    document.getElementById("signin").style.display = "none";
    document.getElementById("forgotPassword").style.display = "block";

  }
  onSubmitForgotPassword() {
    this.isSubmitted = true;
    if (this.forgotPasswordForm.invalid) {
      console.log("254", this.forgotPasswordForm)
      return;
    }
    var data = {
      username: this.j.phone_no.value,
      entity_type: this.currentUser,
      device_token: this.deviceToken
    }
    this.phoneNumber = this.j.phone_no.value;
    console.log("790 phoneNumber:", this.phoneNumber)
    this.ngxUiLoaderService.start();
    this.api.forgotPassword(data).pipe(first())
      .subscribe(res => {
        this.isSubmitted = false;
        this.block_message = res;
        this.ngxUiLoaderService.stop();
        if (res.status == 200) {
          this.forgotPasswordForm.reset();
          document.getElementById("forgotPassword").style.display = "none";
          document.getElementById("forgotPasswordOtp").style.display = "block";
          this.countDown();
        } else {
          if (this.block_message.block == 1) {
            $('#myModal').modal('show');
          }
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
        });

  }
  onSubmitForgotOtp() {
    this.isSubmitted = true;
    if (this.otpFormForgotPassword.invalid) {
      console.log("254", this.otpForm)
      return;
    }
    var data = {
      username: this.phoneNumber,
      otp: this.k.otp1.value + this.k.otp2.value + this.k.otp3.value + this.k.otp4.value,
      entity_type: this.currentUser,
      device_token: this.deviceToken
    };
    console.log("260", data);
    this.ngxUiLoaderService.start();
    this.api.forgotOtp(data).pipe(first())
      .subscribe(res => {
        this.isSubmitted = false;
        this.ngxUiLoaderService.stop();
        console.log('792', res)
        this.block_message = res;
        if (res.status == 200) {
          this.otpFormForgotPassword.reset();
          this.countdownSubscription.unsubscribe();
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
          document.getElementById("forgotPasswordOtp").style.display = "none";
          document.getElementById("resetPassword").style.display = "block";
        } else {
          this.ngxUiLoaderService.stop();
          if (this.block_message.block == 1) {
            $('#myModal').modal('show');
          }
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }

      },
        error => {
          this.ngxUiLoaderService.stop();
        });

  }
  onSubmitResetPassword() {
    this.isSubmitted = true;
    if (this.resetPasswordForm.invalid) {
      console.log("254", this.otpForm)
      return;
    }
    var data = {
      username: this.phoneNumber,
      new_password: this.l.password.value,
      confirm_password: this.l.confirmPassword.value,
      entity_type: this.currentUser,
    };
    console.log("260", data);
    this.ngxUiLoaderService.start();
    this.api.resetPassword(data).pipe(first())
      .subscribe(res => {
        this.isSubmitted = false;
        this.ngxUiLoaderService.stop();
        console.log('792', res)
        if (res.status == 200) {
          $('#signinModal').modal('hide');
          this.resetPasswordForm.reset();
          document.getElementById("resetPassword").style.display = "none";
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });

        } else {
          this.ngxUiLoaderService.stop();
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }

      },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }
  onSubmitChangePassword() {
    this.isSubmitted = true;
    if (this.EmployeeChangePasswordForm.invalid) {
      return;
    }
    var data = {
      new_password: this.m.password.value,
      confirm_password: this.m.confirmPassword.value
    };
    console.log("260", data);
    this.ngxUiLoaderService.start();
    this.api.employeePasswordChange(data).pipe(first())
      .subscribe(res => {
        this.isSubmitted = false;
        this.ngxUiLoaderService.stop();
        console.log('792', res)
        if (res.status == 200) {
          this.getAccountData();
          $('#signinModal').modal('hide');
          document.getElementById("otpSignIn").style.display = "none";
          document.getElementById("signin_as").style.display = "block";
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });

        } else {
          this.ngxUiLoaderService.stop();
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }

      },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }
  logout() {
    this.closeSignInModal();
    this.authenticationService.logout();
    this.anpiService.emitEvent();
    this.login = '';
    this.isBusiness = false;
    setTimeout(() => {
      this.currentValue = this.authenticationService.currentUserValue;
    }, 200)
  }
  getCnssPage() {
    if (this.accountDetails.cnss == 1) {
      this.router.navigate(['/cnss-reportList']);
    } else {
      this.router.navigate(['/cnss-reports']);
    }
  }
  getCnamgsPage() {
    if (this.accountDetails.cnamgs == 1) {
      this.router.navigate(['/cnamgs-reportlist']);
    } else {
      this.router.navigate(['/cnamgs-report']);
    }
  }

  navigateToAddEmployee() {
    this.router.navigate(['/employees'], { queryParams: { openModal: 'addEmployee' } });
  }

  navigateToCnssEmployeeRegistration() {
    this.router.navigate(['/employees'], { queryParams: { openModal: 'cnssEmployeeRegistration' } });
  }

  navigateToCnamgsEmployeeRegistration() {
    this.router.navigate(['/employees'], { queryParams: { openModal: 'cnamgsEmployeeRegistration' } });
  }

  countDown() {
    this.isCountDown = true;
    const countdown$ = timer(0, 1000).pipe(
      take(61),
      map(secondsElapsed => 60 - secondsElapsed)
    );

    this.countdownSubscription = countdown$.subscribe(
      secondsLeft => {
        this.secondsLeft = secondsLeft;
      },
      () => { }, // Error handler
      () => {
        // Completion handler
        console.log('Countdown completed!');
        this.isCountDown = false;
      }
    );
  }
  resendOtp() {
    this.otpFormSignIn.reset();
    this.otpForm.reset();
    this.otpFormForgotPassword.reset();
    // this.ngxUiLoaderService.start();
    let data = {
      mobile: this.phoneNumber,
      entity_type: this.currentUser
    }
    this.ngxUiLoaderService.start();
    console.log("948", data)
    if (data) {
      this.api.loginOtpResend(data).pipe(first())
        .subscribe(res => {
          this.ngxUiLoaderService.stop();
          console.log('792', res)
          if (res.status == 200) {
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
            this.countDown();
          } else {

            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }

        },
          error => {
            this.ngxUiLoaderService.stop();
          });
    }
  }
  openChangePassword() {

    setTimeout(function () {
      document.getElementById("signin").style.display = "none";
      document.getElementById("signin_as").style.display = "none";
      document.getElementById("ChangePasswordEmployee").style.display = "block";
      $('#signinModal').modal('show');

    }, 700);
  }

  goBack() {
    $('#signin_as').toggle();
    $('#signin').hide();
    this.signInForm.reset();
  }

  getUuid() {

    const data = localStorage.getItem('device_id');
    if (data) {
      this.deviceToken = data;
      console.log("deviceToken fcm", this.deviceToken)
    } else {

      const pushtoken = localStorage.getItem('pushtoken');
      if (pushtoken) {
        this.uuid = pushtoken;
        console.log("uuid", this.uuid)
        this.generateDeviceToken();
      } else {
        console.log("297")
        const timestamp = new Date().getTime();
        const array = new Uint32Array(8);
        window.crypto.getRandomValues(array);
        let token = '';
        array.forEach(value => {
          token += value.toString(16);
        });
        this.uuid = `${token}-${timestamp}`;
        console.log("uuid", this.uuid)
        this.generateDeviceToken();
      }


    }

  }
  getDeviceDetails() {
    this.deviceDetails = {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      appName: navigator.appName,
      appVersion: navigator.appVersion,
      vendor: navigator.vendor
    };
    console.log("332", this.deviceDetails)
    this.getUuid();
  }
  generateDeviceToken() {

    if (this.uuid) {
      this.ngxUiLoaderService.start();
      let data = {
        uuid: this.uuid,
        device: this.deviceDetails
      }
      this.api.generateToken(data).pipe(first())
        .subscribe(res => {
          this.ngxUiLoaderService.stop();
          this.response = res;
          if (this.response.status == 200) {

            this.deviceToken = this.response.token;
            console.log(this.deviceToken)
            localStorage.setItem('device_id', this.deviceToken);
          } else {

            // this.snackBar.open(this.response.message, "OK", {
            //     duration: 5000,
            // });
          }

        },
          error => {
            this.ngxUiLoaderService.stop();
          });
    }

  }


  closemyModal() {
    $('#myModal').modal('hide');
  }


  openPaymentDetailsModal() {


    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);

      if (this.accountDetails.BankDetails == '1') {
        this.router.navigate(['/profile'], { state: { profile_section: 'sidenav3' } });
      } else {

        $('#bankAccountModal').modal('show');

      }
    }
  }


  goTocnamgsEmployer() {
    if (this.accountDetails.cnamgs == 0 || this.accountDetails.cnamgs == 3) {
      this.router.navigate(['/cnamgs-form']);
    } else if (this.accountDetails.cnamgs == 2) {
      this.messageTitle = 'CNAMGS Approval is Pending';
      this.messageDescription = 'The information inserted has been sent for verification by the CNAMGS and is awaiting activation';
      $('#headerMessageModal').modal('show');
      this.is_cnamgsPdf = true;
    } else if (this.accountDetails.cnamgs == 1) {
      const url = this.accountDetails.cnamgs_url;
      window.open(url, '_blank');
    }
  }

  goTocnssEmployer() {
    if (this.accountDetails.cnss == 0 || this.accountDetails.cnss == 3) {
      this.router.navigate(['/cnss-approval-form']);
    } else if (this.accountDetails.cnss == 2) {
      this.messageTitle = 'CNSS Approval is Pending';
      this.messageDescription = 'The information inserted has been sent for verification by the CNSS and is awaiting activation';
      $('#headerMessageModal').modal('show');
      this.is_cnssPdf = true;
    } else if (this.accountDetails.cnss == 1) {
      const url = this.accountDetails.cnss_url;
      window.open(url, '_blank');
    }
  }

  closeModal() {
    $('#headerMessageModal').modal('hide');
    this.is_cnamgsPdf = false;
    this.is_cnssPdf = false;
    this.messageTitle = '';
    this.messageDescription = '';

  }

  getFaqList() {
    this.ngxUiLoaderService.start();
    this.api.getFaqList().pipe(first())
      .subscribe(res => {
        this.ngxUiLoaderService.stop();
        this.response = res;
        if (this.response.status == 200) {
          this.faqAllList = this.response.results;
          this.faqDetails = this.response.results;
          console.log("this.faqDetails");
          console.log(this.faqDetails);
          // this.hideshow() ;
        } else {
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  toggleAnswer(index: number) {
    if (this.openFaqIndices.has(index)) {
      this.openFaqIndices.delete(index);
    } else {
      this.openFaqIndices.add(index);
    }
  }

}
